export default __webpack_public_path__ + "static/media/8.7c886b74.png";